export default __webpack_public_path__ + "static/media/ARIBLK.56ef8cad.ttf";